export const TEXT = {
    EDIT_PROFILE: 'Edit Profile'
};